import { isTrieCacheEnabled } from 'owa-substrate-people-suggestions/lib/utils/isTrieCacheEnabled';

const BASE_SUGGESTION_FIELDS = [
    'Id',
    'ADObjectId',
    'DisplayName',
    'EmailAddresses',
    'PeopleSubtype',
    'PeopleType',
    'PDLItemId',
    'PersonaId',
    'ImAddress',
    'JobTitle',
];

export function getSubstrateSuggestionFields(): string[] {
    return isTrieCacheEnabled()
        ? BASE_SUGGESTION_FIELDS.concat(['FeatureData', 'GivenName'])
        : BASE_SUGGESTION_FIELDS;
}
